<div class="fx-row gap-16 notice" [ngClass]="level()" [classList]="cssClasses()">
  <mat-icon class="dark fx-shrink-0 notice-icon" fontSet="material-icons-outlined">{{ iconName() }}</mat-icon>
  <div class="fx-column gap-8 notice-content">
    @if (title()) {
      <span class="text bold notice-title">{{ title() }}</span>
    }
    <span class="text notice-text">{{ content() }}</span>
  </div>
</div>
